import React from 'react';
import cn from 'classnames';

import { useGilt } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import CN from './CashupTableRow.module.scss'; // common for deposit, cash and voucher tabs

const PettyCashLogItem = (props) => {
  const { isDarkMode } = useTheme();
  const { formatDate } = useGilt();

  const displayTime = formatDate(props.date, { hideDate: true });
  const displayDate = formatDate(props.date, { hideTime: true, hideWeekday: true });

  return (
    <div
      data-bem="PettyCashLogItem"
      className={cn({
        [CN.tableRow]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.fixedColumnCell}>
        <span>{displayTime} </span>
        <span>{displayDate}</span>
      </div>
      <div className={CN.cell}>
        <span>{props.pettyCash}</span>
      </div>
      <div
        className={cn({
          [CN.cell]: true,
          [CN.lgWidth]: true,
        })}
      >
        <span>{props.notes}</span>
      </div>
    </div>
  );
};

export default PettyCashLogItem;
